import store from '@/store'
import commonAxios from '@/common/axios'
import config from '@/common/config'
import axios from 'axios'
import { ElMessageBox } from "element-plus";
import tips from '@/common/tips'
// 工具模块
const tool = {
  clickTime: 0,
  noScroll(e) { e.preventDefault() },
  setCookie(key, value, time = 24) {
    var date = new Date();
    date.setTime(date.getTime() + (time * 60 * 60 * 1000));
    var expires = "expires=" + date.toGMTString();
    document.cookie = key + "=" + value + "; " + expires;
  },
  getCookie(key) {
    var name = key + "=";
    var params = document.cookie.split(';');
    for (var i = 0; i < params.length; i++) {
      var item = params[i].trim();
      if (item.indexOf(name) == 0) return item.substring(name.length, item.length);
    }
    return "";
  },
  setLocalCookie(key, value, time = 24) {
    console.log("set", key)
    let data = {
      val: value,
      time: Date.now() + time * 60 * 60 * 1000
    }
    tool.setStorage(`${key}_cookie`, data)

  },
  getLocalCookie(key) {
    let data = tool.getStorage(`${key}_cookie`) || { val: '', time: 0 }
    if (Date.now() < data.time) {
      return data.val;
    } else {
      return '';
    }
  },
  setStorage(key, val, storage) {
    storage = storage || localStorage
    let data = {
      value: val
    }
    key = `${tool.getEnvName(config.project)}-admin-${key}`
    storage.setItem(key, JSON.stringify(data));
  },
  // no-extra-boolean-cast
  getStorage(key, storage) {
    key = `${tool.getEnvName(config.project)}-admin-${key}`
    storage = storage || localStorage
    let data = storage.getItem(key);
    if (!data) return data;
    data = JSON.parse(data);
    return data.value
  },
  isDevelopment() {
    return window.location.pathname.includes("/manage/dev")
  },
  getEnvName(name) {
    if (!tool.isLocal()) return name
    // if(!tool.isDevelopment()) return name
    return `${name}`
  },
  formatData(key, value) {
    if (value === '' || value === null || value === undefined) return '暂无';
    let text = '';
    switch (key) {
      case "disabled":
        text = config.types.disabledStatus[value]
        break;
      default:
        text = value;
    }
    return text;
  },
  getFormData(item) {
    let data = new FormData();
    for (let key in item) {
      data.append(key, item[key])
    }
    return data;
  },
  getURL(url, data = {}) {
    let index = 0;
    for (let key in data) {
      let _symbol = index++ === 0 ? '?' : '&';
      url += `${_symbol}${key}=${encodeURIComponent(data[key])}`
    }
    return url;
  },
  getTimeText(time) {
    time = String(time)
    return time[1] ? time : `0${time}`
  },
  // 获取时间戳
  getFormatTime(time = "") {
    if (typeof time == "object" && time != null) return time;
    if (typeof time == "string") time = time.replace(/-/g, "/");
    return time ? new Date(time) : new Date();
  },
  getDateTime(time) {
    let value = 0;
    try {
      let dealWithTime = tool.getFormatTime(time)
      value = dealWithTime.getTime();
    } catch (err) { console.log(err) }
    return value
  },
  getDate(time, format = "yyyy-MM-dd") {
    let date = tool.getFormatTime(time);
    let dateItem = {
      yyyy: date.getFullYear(),
      MM: tool.getTimeText(date.getMonth() + 1),
      dd: tool.getTimeText(date.getDate()),
      hh: tool.getTimeText(date.getHours()),
      mm: tool.getTimeText(date.getMinutes()),
      ss: tool.getTimeText(date.getSeconds())
    };
    let text = format;
    for (let key in dateItem) {
      text = text.replace(key, dateItem[key])
    }
    return text;
  },

  // 获取当前日期
  getTime(time, separator = '-') {
    let date = time ? new Date(time) : new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let monthText = month < 10 ? `0${month}` : month;
    let dayText = day < 10 ? `0${day}` : day;
    return `${year}${separator}${monthText}${separator}${dayText}`
  },
  // 获取上周日期
  getPrepWeek() {
    let date = new Date();
    let day = date.getDay();
    let curTime = date.getTime();
    let prepstartDay = curTime - (day + 7 - 1) * 24 * 60 * 60 * 1000;
    let prepEndDay = curTime - day * 24 * 60 * 60 * 1000;
    return {
      start_time: tool.getTime(prepstartDay),
      end_time: tool.getTime(prepEndDay)
    }
  },

  // 获取上个月日期
  getPrepMonth() {
    let date = new Date();
    let day = date.getDate();
    let curTime = date.getTime();
    let prepEndDay = curTime - day * 24 * 60 * 60 * 1000;
    let preDate = new Date(prepEndDay);
    let preTime = preDate.getTime();
    let preYear = preDate.getFullYear();
    let preMonth = preDate.getMonth() + 1;
    let preCountDay = new Date(preYear, preMonth, 0).getDate()
    let prepstartDay = preTime - (preCountDay - 1) * 24 * 60 * 60 * 1000;
    return {
      start_time: tool.getTime(prepstartDay),
      end_time: tool.getTime(prepEndDay)
    }

  },
  getTableConfig: async function (key) {
    return new Promise((resolve) => {
      import('@/common/data/table.json').then(data => {
        let item = data[key] || {}
        resolve({ ...data.defaultConfig, ...item })
      })
    })
  },
  getMenusConfig: async function () {
    return new Promise((resolve) => {
      import('@/common/data/menus.json').then(data => {
        resolve(data)
      })
    })
  },
  getDataForKey(data, key) {
    if (data[key]) return data[key]
    let values = Object.values(data)
    let keys = Object.keys(data)
    return keys[values.indexOf(key)]
  },
  delayClick(callback, params = {}) {
    if (tool.clickTime + 1000 > Date.now()) return;
    tool.clickTime = Date.now();
    callback(params)
  },

  verifyPermission(permission) {
    return !!store.state?.common.permissions?.[permission] || !config.authentication
  },
  deepCopy(data) {
    return JSON.parse(JSON.stringify(data))
  },
  isLocal() {
    const localURL = /^(192\.168\.\d{1,3}\.\d{1,3})|(localhost)|(172\.16\.\d{1,3}\.\d{1,3})$/;
    let hostname = window.location.hostname;
    return localURL.test(hostname)
  },
  sleep(timer = 50) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve()
      }, timer)
    })
  },
  getFileNameFromURL(fileUrl) {
    if (!fileUrl) return ""
    return fileUrl.substring(fileUrl.lastIndexOf("/") + 1);
  },
  getFileName(fileUrl) {
    return tool.getFileNameFromURL(fileUrl);
  },
  //将数字的金额转为中文大写
  numberToChinese(str) {
    str = str ? str : 0;
    let num = parseFloat(str);
    let strOutput = "", strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
    num += "00";
    let intPos = num.indexOf('.');
    if (intPos >= 0) {
      num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
    }
    strUnit = strUnit.substr(strUnit.length - num.length);
    for (let i = 0; i < num.length; i++) {
      strOutput += '零壹贰叁肆伍陆柒捌玖'.substr(num.substr(i, 1), 1) + strUnit.substr(i, 1);
    }
    let text = strOutput.replace(/零角零分$/, '整').replace(/零[仟佰拾]/g, '零').replace(/零{2,}/g, '零').replace(/零([亿|万])/g, '$1').replace(/零+元/, '元').replace(/亿零{0,3}万/, '亿').replace(/^元/, "零元")
    return text;
  },
  getFileTypeFromURL(fileUrl) {
    if (!fileUrl) return ""
    fileUrl = fileUrl?.split("?").splice(0, 1)[0]
    let fileType = fileUrl?.split(".").splice(-1, 1)[0]
    return fileType.toLowerCase();
  },
  sortChinese(data, key) {
    let dataList = []
    dataList = key ? data.sort((params1, params2) => {
      return params1[key].localeCompare(params2[key], "zh")
    })
      :
      dataList = data.sort((params1, params2) => {
        return params1.localeCompare(params2, "zh")
      })
    return dataList;
  },
  isPc() {
    let userAgentInfo = navigator.userAgent;
    let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break
      }
    }
    return flag;
  },
  //a标签下载
  aTagDownLoad(url) {
    if (url) {
      const fileName = url?.split("/").splice(-1, 1)[0];
      const fileType = url?.split(".").splice(-1, 1)[0];
      if (!(/jpg|jpeg|png|pdf/gi.test(fileType))) {
        // window.open(url);
        window.location.href = url;
      } else {
        fetch(url).then(res => res.blob().then(blob => {
          let a = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = fileName
          a.click()
          window.URL.revokeObjectURL(url)
        }))
      }
    }
  },
  downLoadFile(url) {
    let userInfo = store.state.common.userInfo || {};
    axios({
      method: "get",
      url,
      data: {},
      processData: false,  // 不处理数据
      contentType: false,   // 不设置内容类型
      headers: { uid: userInfo.id || "" }
    }).then((res) => {
      if (res.data.code == 200) {
        const a = document.createElement("a");
        a.href = res.data.data; // 窗口的链接
        a.target = "_blank";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      if (res.data.code == 204 || res.data.code == 202) {
        if (res.data.code == 202) {
          tips.error({ text: '密码错误,请重新输入密码' })
        }
        ElMessageBox.prompt("请输入密码", "提醒", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          inputPattern: /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{16}$/,
          inputErrorMessage: "请输入16位数字加字母组成的密码",
        })
          .then(({ value }) => {
            let newUrl = `${url}&password=${value}`;
            this.downLoadFile(newUrl)

          })
          .catch(() => {

          });
      }
    }).catch((err) => {
      console.log(err);
    })
  },
  //数字千位符格式化
  addCommas(num) {
    var numToFixed = Number(num).toFixed(2);
    var parts = numToFixed.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join('.');
  },
  //计算申请金额表的合计
  getSumMoney({ columns, data }) {
    const sums = [];
    columns.forEach((column, index) => {
      if (index === 0) {
        sums[index] = "合计";
      } else {
        const values = data.map((item) => item[column.property]);
        let total = values.reduce((prev, curr) => Number(prev) + Number(curr), 0);
        total = Number(total).toFixed(2);
        sums[index] = total;
      }
    });
    return sums;
  },
  loadPendingNum(url) {
    return new Promise((resolve, reject) => {
      commonAxios.get(url).then(res => {
        tool.setStorage("pendingNum", res.count || 0);
        resolve(res.count)
      }).catch(err => {
        console.log("err")
        tool.setStorage("pendingNum", 0);
        reject(err)
      })
    })
  },
  //项目执行需求发送是否是新版
  isNewProjectExe(created_time) {
    //2024/09/23 12:00:00之后创建的需求视为最新
    return created_time > new Date("2024/09/23 12:00:00").getTime();
  },
  // 模拟延迟函数
  delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },
  getSystemInfo() {
    let app = navigator.appVersion;
    let leftIndex = app.indexOf('(');
    let rightIndex = app.indexOf(')');
    let text = app.substring(leftIndex + 1, rightIndex);
    text = text.split(";");
    var Mobile_Iphone = text[0];
    var Mobile_Android = text[2];
    var res = /Android/;
    var result = res.test(Mobile_Android);
    let data = {
      device: Mobile_Iphone,
      version: '',
      width: window.screen.width,
      height: window.screen.height,
    }
    switch (Mobile_Iphone) {
      case 'Linux':
        let device = ''
        if (result) {
          device = text[4]
          data.version = text[2]
        } else {
          device = Mobile_Android
          data.version = text[1]
        }
        data.device = device.split('Build')[0]
        break;
      case 'iPhone': ;
      case 'iPad':
        data.device = text[0];
        let version = text[1].match(/OS\s([\d\_]+)\slike/g);
        version = version ? version[0] : '';
        data.version = version.split(/\s/)[1] ? `ios ${version.split(/\s/)[1]}` : ''
        break;
    }
    data.device = String(data.device).trim()
    data.version = String(data.version).trim().replace(/_/g, '.')
    return data;
  },
  removeTouch() {
    document.body.removeEventListener("touchmove", noScroll, { passive: false })
  },
  addTouch() {
    document.body.addEventListener('touchmove', noScroll, { passive: false })
  },
}

export default tool;
